import {DEFAULT_WORKSPACE_KEY} from './default-workspace-key';

export function setDefaultWorkspace(defaultWorkspace: Record<string, number>) {
  window.localStorage.setItem(DEFAULT_WORKSPACE_KEY, JSON.stringify(defaultWorkspace));
}
